import { Component, computed, input, output } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { SelectionCardComponent } from '@valk-nx/components/ui-selection-card/src/lib/selection-card';
import type { SelectionCardInterface } from '@valk-nx/components/ui-selection-card/src/lib/selection-card.interface';

import type { FiltersItemInterface } from '../../contracts/filters.interface';
import { uniqueGroupName } from '../unique-group-name';

@Component({
	selector: `vp-filter-layout`,
	templateUrl: './filter-layout.html',
	host: { class: 'contents' },
	imports: [SelectionCardComponent, TranslatePipe],
})
export class FilterLayoutComponent {
	title = input.required<string>();
	items = input<FiltersItemInterface[]>([]);
	activeValues = input<string[]>([]);

	changed = output<string[]>();

	protected readonly groupName = uniqueGroupName(this.title);
	protected readonly labelId = computed(() => `${this.groupName()}-label`);

	protected readonly options = computed<SelectionCardInterface[]>(() =>
		this.items().map((item) => ({
			label: item.name,
			inputId: this.inputIdFor(item.value),
			icon: item.icon
				? `assets/icons/layout-${item.icon}.svg`
				: undefined,
			selected: this.activeValues().includes(item.value),
		})),
	);

	onOptionsChange(options: SelectionCardInterface[]): void {
		const selectedIds = new Set(
			options
				.filter((option) => option.selected)
				.map((option) => option.inputId),
		);

		this.changed.emit(
			this.items()
				.filter((item) => selectedIds.has(this.inputIdFor(item.value)))
				.map((item) => item.value),
		);
	}

	private inputIdFor(value: string): string {
		return `${this.groupName()}-${value}`;
	}
}
